import React from "react";

import Box from "./Box";
import Button from "./Button";
import Label from "./Label";
import { LineItem } from "gpc-shared-types";

export type OrderSelectProps = {
  items?: LineItem[];
  onButtonClick?: () => void;
  buttonLabel?: string;
  buttonDisabled?: boolean;
};
export const OrderSelect = ({
  items = [],
  onButtonClick,
  buttonLabel = "Submit",
  buttonDisabled = false,
}: OrderSelectProps) => {
  return (
    <Box>
      <div className="gpc__order-select">
        <Label>{items.length} items selected for cancellation</Label>
        <div className="gpc__item-list">
          {items.map((item) => (
            <div key={item.id} className="gpc__item-line__selected-item">
              <div className="gpc__item-line__selected-image">
                {item != null && item.image != null ? (
                  <img src={`${item.image.url}`} alt="item" />
                ) : (
                  <img
                    src="https://cdn.shopify.com/s/files/1/0726/8489/6566/products/Main_b9e0da7f-db89-4d41-83f0-7f417b02831d.jpg?v=1676244627"
                    alt="item"
                  />
                )}

                {/* <img
                  src="https://cdn.shopify.com/s/files/1/0726/8489/6566/products/Main_b9e0da7f-db89-4d41-83f0-7f417b02831d.jpg?v=1676244627"
                  alt="item"
                /> */}
              </div>
              <div className="mobile-selected-title">{item.title}</div>
            </div>
          ))}
        </div>
        <Button active onClick={onButtonClick} disabled={buttonDisabled}>
          {buttonLabel}
        </Button>
      </div>
    </Box>
  );
};

export default OrderSelect;
